function smoothScrollTo(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    const offset = 80;
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  }
}

// Asegurar que la imagen siempre cubra el contenedor
window.addEventListener('load', function() {
  const heroImage = document.querySelector('.skull-hero__image');
  if (heroImage && window.innerWidth > 768) {
    function adjustImage() {
      const container = document.querySelector('.skull-hero__bg');
      const containerRatio = container.offsetWidth / container.offsetHeight;
      const imageRatio = heroImage.naturalWidth / heroImage.naturalHeight;
      
      if (containerRatio > imageRatio) {
        heroImage.style.width = '100%';
        heroImage.style.height = 'auto';
      } else {
        heroImage.style.width = 'auto';
        heroImage.style.height = '100%';
      }
    }
    
    adjustImage();
    window.addEventListener('resize', adjustImage);
  }
});
